
export const placeHolder = {
    page: 'market',
    title: '营销图生成',
    subtitle: '快速生成图片，可快速进行局部优化',
    src: 'https://qiaojiang.bj.bcebos.com/fe/static/images/Demo_MarketGenerate%404x.mp4'
};

export const historyParams = {
    pageNo: 1,
    pageSize: 20,
    taskType: [17]
};


// 布局的信息，使用参数计算会需要用到
export const layoutModuleMap = {
    2: [
        {
            key: '2-1',
            activeUrl: 'https://feed-image.baidu.com/0/pic/2064454091_-1513743090_668838154.png',
            url: 'https://feed-image.baidu.com/0/pic/-236002349_2075040589_989807937.png',
            itemSize: [
                {
                    widthFac: 1,
                    heightFac: 0.5,
                    widthSpaceFac: 0,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 1,
                    heightFac: 0.5,
                    widthSpaceFac: 0,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.5,
                    leftSpaceFac: 0,
                    topSpaceFac: 1
                }
            ]
        },
        {
            key: '2-2',
            activeUrl: 'https://feed-image.baidu.com/0/pic/-1640639618_1647239941_-933976982.png',
            url: 'https://feed-image.baidu.com/0/pic/803818640_1153528956_619689429.png',
            itemSize: [
                {
                    widthFac: 0.5,
                    heightFac: 1,
                    widthSpaceFac: 1,
                    heightSpaceFac: 0,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.5,
                    heightFac: 1,
                    widthSpaceFac: 1,
                    heightSpaceFac: 0,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.5,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                }
            ]
        }
    ],
    3: [
        {
            key: '3-1',
            activeUrl: 'https://feed-image.baidu.com/0/pic/887221007_964220498_294022179.png',
            url: 'https://feed-image.baidu.com/0/pic/-1952768304_1100308812_1992898986.png',
            itemSize: [
                {
                    widthFac: 0.333333333,
                    heightFac: 1,
                    widthSpaceFac: 2,
                    heightSpaceFac: 0,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.333333333,
                    heightFac: 1,
                    widthSpaceFac: 2,
                    heightSpaceFac: 0,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.33,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.333333333,
                    heightFac: 1,
                    widthSpaceFac: 2,
                    heightSpaceFac: 0,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.66,
                    topFac: 0,
                    leftSpaceFac: 2,
                    topSpaceFac: 0
                }
            ]
        },
        {
            key: '3-2',
            activeUrl: 'https://feed-image.baidu.com/0/pic/-1372822211_-1359134055_-1500319962.png',
            url: 'https://feed-image.baidu.com/0/pic/404010786_1436657395_-1803613337.png',
            itemSize: [
                {
                    widthFac: 1,
                    heightFac: 0.33333333,
                    widthSpaceFac: 0,
                    heightSpaceFac: 2,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 1,
                    heightFac: 0.33333333,
                    widthSpaceFac: 0,
                    heightSpaceFac: 2,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0.33,
                    leftSpaceFac: 0,
                    topSpaceFac: 1
                },
                {
                    widthFac: 1,
                    heightFac: 0.33333333,
                    widthSpaceFac: 0,
                    heightSpaceFac: 2,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.66,
                    leftSpaceFac: 0,
                    topSpaceFac: 2
                }
            ]
        },
        {
            key: '3-3',
            activeUrl: 'https://feed-image.baidu.com/0/pic/-1273687335_-934130618_160258745.png',
            url: 'https://feed-image.baidu.com/0/pic/-238803854_-801031580_593340273.png',
            itemSize: [
                {
                    widthFac: 0.5,
                    heightFac: 1,
                    widthSpaceFac: 1,
                    heightSpaceFac: 0,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.5,
                    heightFac: 0.5,
                    widthSpaceFac: 1,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.5,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.5,
                    heightFac: 0.5,
                    widthSpaceFac: 1,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.5,
                    topFac: 0.5,
                    leftSpaceFac: 1,
                    topSpaceFac: 1
                }
            ]
        },
        {
            key: '3-4',
            activeUrl: 'https://feed-image.baidu.com/0/pic/-1483845313_1326908930_2024491433.png',
            url: 'https://feed-image.baidu.com/0/pic/-425517093_552436392_194583218.png',
            itemSize: [
                {
                    widthFac: 0.5,
                    heightFac: 0.5,
                    widthSpaceFac: 1,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.5,
                    heightFac: 1,
                    widthSpaceFac: 1,
                    heightSpaceFac: 0,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.5,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.5,
                    heightFac: 1,
                    widthSpaceFac: 1,
                    heightSpaceFac: 0,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.5,
                    leftSpaceFac: 0,
                    topSpaceFac: 0.5
                }
            ]
        },
        {
            key: '3-5',
            activeUrl: 'https://feed-image.baidu.com/0/pic/2060637184_868090187_-397211658.png',
            url: 'https://feed-image.baidu.com/0/pic/-392973680_791707296_387854381.png',
            itemSize: [
                {
                    widthFac: 1,
                    heightFac: 0.5,
                    widthSpaceFac: 0,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.5,
                    heightFac: 0.5,
                    widthSpaceFac: 1,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.5,
                    leftSpaceFac: 0,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.5,
                    heightFac: 0.5,
                    widthSpaceFac: 1,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.5,
                    topFac: 0.5,
                    leftSpaceFac: 1,
                    topSpaceFac: 1
                }
            ]
        },
        {
            key: '3-6',
            activeUrl: 'https://feed-image.baidu.com/0/pic/47940485_1012745066_-1352694411.png',
            url: 'https://feed-image.baidu.com/0/pic/-1587427446_1276280475_469258939.png',
            itemSize: [
                {
                    widthFac: 0.5,
                    heightFac: 0.5,
                    widthSpaceFac: 0,
                    heightSpaceFac: 0,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.5,
                    heightFac: 0.5,
                    widthSpaceFac: 1,
                    heightSpaceFac: 0,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.5,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 1,
                    heightFac: 0.5,
                    widthSpaceFac: 0,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.5,
                    leftSpaceFac: 0,
                    topSpaceFac: 1
                }
            ]
        }
    ],
    4: [
        {
            key: '4-1',
            activeUrl: 'https://feed-image.baidu.com/0/pic/-1514308273_430166069_1930149626.png',
            url: 'https://feed-image.baidu.com/0/pic/3305159_1791395542_-101806271.png',
            itemSize: [
                {
                    widthFac: 0.5,
                    heightFac: 0.5,
                    widthSpaceFac: 1,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.5,
                    heightFac: 0.5,
                    widthSpaceFac: 1,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.5,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.5,
                    heightFac: 0.5,
                    widthSpaceFac: 1,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.5,
                    leftSpaceFac: 0,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.5,
                    heightFac: 0.5,
                    widthSpaceFac: 1,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.5,
                    topFac: 0.5,
                    leftSpaceFac: 1,
                    topSpaceFac: 1
                }
            ]
        },
        {
            key: '4-2',
            activeUrl: 'https://feed-image.baidu.com/0/pic/1633666450_1885578407_-1454655205.png',
            url: 'https://feed-image.baidu.com/0/pic/1069773775_1265876628_1452592532.png',
            itemSize: [
                {
                    widthFac: 0.25,
                    heightFac: 1,
                    widthSpaceFac: 3,
                    heightSpaceFac: 0,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.25,
                    heightFac: 1,
                    widthSpaceFac: 3,
                    heightSpaceFac: 0,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.25,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.25,
                    heightFac: 1,
                    widthSpaceFac: 3,
                    heightSpaceFac: 0,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.5,
                    topFac: 0,
                    leftSpaceFac: 2,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.25,
                    heightFac: 1,
                    widthSpaceFac: 3,
                    heightSpaceFac: 0,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.75,
                    topFac: 0,
                    leftSpaceFac: 3,
                    topSpaceFac: 0
                }
            ]
        },
        {
            key: '4-3',
            activeUrl: 'https://feed-image.baidu.com/0/pic/578617015_-1446480195_875595421.png',
            url: 'https://feed-image.baidu.com/0/pic/1804581702_-990945405_1240056609.png',
            itemSize: [
                {
                    widthFac: 1,
                    heightFac: 0.25,
                    widthSpaceFac: 0,
                    heightSpaceFac: 3,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 1,
                    heightFac: 0.25,
                    widthSpaceFac: 0,
                    heightSpaceFac: 3,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0.25,
                    leftSpaceFac: 0,
                    topSpaceFac: 1
                },
                {
                    widthFac: 1,
                    heightFac: 0.25,
                    widthSpaceFac: 0,
                    heightSpaceFac: 3,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0.5,
                    leftSpaceFac: 0,
                    topSpaceFac: 2
                },
                {
                    widthFac: 1,
                    heightFac: 0.25,
                    widthSpaceFac: 0,
                    heightSpaceFac: 3,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.75,
                    leftSpaceFac: 0,
                    topSpaceFac: 3
                }
            ]
        },
        {
            key: '4-4',
            activeUrl: 'https://feed-image.baidu.com/0/pic/-66749676_1018530917_-644044766.png',
            url: 'https://feed-image.baidu.com/0/pic/-1518888848_-1575283691_1656359235.png',
            itemSize: [
                {
                    widthFac: 1,
                    heightFac: 0.5,
                    widthSpaceFac: 0,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.5,
                    leftSpaceFac: 0,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.33333333,
                    topFac: 0.5,
                    leftSpaceFac: 1,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.66666666,
                    topFac: 0.5,
                    leftSpaceFac: 2,
                    topSpaceFac: 1
                }
            ]
        },
        {
            key: '4-5',
            activeUrl: 'https://feed-image.baidu.com/0/pic/-347628495_332973168_1039919605.png',
            url: 'https://feed-image.baidu.com/0/pic/-1520414915_-466369108_552336598.png',
            itemSize: [
                {
                    widthFac: 0.3333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0.33333333,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.66666666,
                    topFac: 0,
                    leftSpaceFac: 2,
                    topSpaceFac: 0
                },
                {
                    widthFac: 1,
                    heightFac: 0.5,
                    widthSpaceFac: 0,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.5,
                    leftSpaceFac: 0,
                    topSpaceFac: 1
                }
            ]
        },
        {
            key: '4-6',
            activeUrl: 'https://feed-image.baidu.com/0/pic/-1621460848_-1115163929_-695397581.png',
            url: 'https://feed-image.baidu.com/0/pic/-2128891557_-758239606_-440512148.png',
            itemSize: [
                {
                    widthFac: 0.66666667,
                    heightFac: 0.5,
                    widthSpaceFac: 1,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 1,
                    widthSpaceFac: 1,
                    heightSpaceFac: 0,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.66666667,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.5,
                    leftSpaceFac: 0,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.33333333,
                    topFac: 0.5,
                    leftSpaceFac: 1,
                    topSpaceFac: 1
                }
            ]
        },
        {
            key: '4-7',
            activeUrl: 'https://feed-image.baidu.com/0/pic/168202490_-1265031222_-580853075.png',
            url: 'https://feed-image.baidu.com/0/pic/6575779_74945124_1334865711.png',
            itemSize: [
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0.33333333,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 1,
                    widthSpaceFac: 2,
                    heightSpaceFac: 0,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.66666667,
                    topFac: 0,
                    leftSpaceFac: 2,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.66666667,
                    heightFac: 0.5,
                    widthSpaceFac: 1,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.5,
                    leftSpaceFac: 0,
                    topSpaceFac: 1
                }
            ]
        },
        {
            key: '4-8',
            activeUrl: 'https://feed-image.baidu.com/0/pic/-1202957796_-1226567287_-1219652725.png',
            url: 'https://feed-image.baidu.com/0/pic/-1494292974_1199662904_474290952.png',
            itemSize: [
                {
                    widthFac: 0.33333333,
                    heightFac: 1,
                    widthSpaceFac: 1,
                    heightSpaceFac: 0,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.66666667,
                    heightFac: 0.5,
                    widthSpaceFac: 1,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.33333333,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.33333333,
                    topFac: 0.5,
                    leftSpaceFac: 1,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.66666667,
                    topFac: 0.5,
                    leftSpaceFac: 2,
                    topSpaceFac: 1
                }
            ]
        },
        {
            key: '4-9',
            activeUrl: 'https://feed-image.baidu.com/0/pic/1522131362_-1944999178_778877141.png',
            url: 'https://feed-image.baidu.com/0/pic/-2079011411_-237413962_-585382737.png',
            itemSize: [
                {
                    widthFac: 0.33333333,
                    heightFac: 1,
                    widthSpaceFac: 2,
                    heightSpaceFac: 0,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0.33,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.66666666,
                    topFac: 0,
                    leftSpaceFac: 2,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.66666667,
                    heightFac: 0.5,
                    widthSpaceFac: 1,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.33,
                    topFac: 0.5,
                    leftSpaceFac: 1,
                    topSpaceFac: 1
                }
            ]
        }
    ],
    5: [
        {
            key: '5-1',
            activeUrl: 'https://feed-image.baidu.com/0/pic/-1255695399_-1159769349_-955951725.png',
            url: 'https://feed-image.baidu.com/0/pic/567856489_-1875468053_303593838.png',
            itemSize: [
                {
                    widthFac: 0.2,
                    heightFac: 1,
                    widthSpaceFac: 4,
                    heightSpaceFac: 0,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.2,
                    heightFac: 1,
                    widthSpaceFac: 4,
                    heightSpaceFac: 0,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.2,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.2,
                    heightFac: 1,
                    widthSpaceFac: 4,
                    heightSpaceFac: 0,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.4,
                    topFac: 0,
                    leftSpaceFac: 2,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.2,
                    heightFac: 1,
                    widthSpaceFac: 4,
                    heightSpaceFac: 0,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.6,
                    topFac: 0,
                    leftSpaceFac: 3,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.2,
                    heightFac: 1,
                    widthSpaceFac: 4,
                    heightSpaceFac: 0,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.8,
                    topFac: 0,
                    leftSpaceFac: 4,
                    topSpaceFac: 0
                }
            ]
        },
        {
            key: '5-2',
            activeUrl: 'https://feed-image.baidu.com/0/pic/1778042497_-769448061_1317919732.png',
            url: 'https://feed-image.baidu.com/0/pic/1227956358_-1431641273_-1410401488.png',
            itemSize: [
                {
                    widthFac: 1,
                    heightFac: 0.8,
                    widthSpaceFac: 0,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.25,
                    heightFac: 0.2,
                    widthSpaceFac: 3,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.8,
                    leftSpaceFac: 0,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.25,
                    heightFac: 0.2,
                    widthSpaceFac: 3,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.25,
                    topFac: 0.8,
                    leftSpaceFac: 1,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.25,
                    heightFac: 0.2,
                    widthSpaceFac: 3,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.5,
                    topFac: 0.8,
                    leftSpaceFac: 2,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.25,
                    heightFac: 0.2,
                    widthSpaceFac: 3,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.75,
                    topFac: 0.8,
                    leftSpaceFac: 3,
                    topSpaceFac: 1
                }
            ]
        },
        {
            key: '5-3',
            activeUrl: 'https://feed-image.baidu.com/0/pic/-1720212256_-340626396_1222339563.png',
            url: 'https://feed-image.baidu.com/0/pic/639611622_1206829481_-1064803499.png',
            itemSize: [
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 1,
                    heightSpaceFac: 2,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.66666667,
                    heightFac: 0.33333333,
                    widthSpaceFac: 1,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.3333333,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 1,
                    heightSpaceFac: 2,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0.3333333,
                    leftSpaceFac: 0,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.66666667,
                    heightFac: 0.66666667,
                    widthSpaceFac: 1,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.33333333,
                    topFac: 0.33333333,
                    leftSpaceFac: 1,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 1,
                    heightSpaceFac: 2,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.66666667,
                    leftSpaceFac: 0,
                    topSpaceFac: 2
                }
            ]
        },
        {
            key: '5-4',
            activeUrl: 'https://feed-image.baidu.com/0/pic/196108510_1773800062_1865386906.png',
            url: 'https://feed-image.baidu.com/0/pic/1187224706_-616445840_370310114.png',
            itemSize: [
                {
                    widthFac: 0.66666667,
                    heightFac: 0.66666667,
                    widthSpaceFac: 1,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 1,
                    heightSpaceFac: 2,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.66666667,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.333333333,
                    heightFac: 0.333333333,
                    widthSpaceFac: 1,
                    heightSpaceFac: 2,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.66666667,
                    topFac: 0.33333333,
                    leftSpaceFac: 1,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.66666667,
                    heightFac: 0.33333333,
                    widthSpaceFac: 1,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.66666667,
                    leftSpaceFac: 0,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.333333333,
                    heightFac: 0.333333333,
                    widthSpaceFac: 1,
                    heightSpaceFac: 2,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.66666667,
                    topFac: 0.66666667,
                    leftSpaceFac: 1,
                    topSpaceFac: 2
                }
            ]
        },
        {
            key: '5-5',
            activeUrl: 'https://feed-image.baidu.com/0/pic/1121678253_-1054833655_473266580.png',
            url: 'https://feed-image.baidu.com/0/pic/1748586392_1496634985_-315664082.png',
            itemSize: [
                {
                    widthFac: 0.5,
                    heightFac: 1,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.25,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0.5,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.25,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0.75,
                    topFac: 0,
                    leftSpaceFac: 2,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.25,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.5,
                    topFac: 0.5,
                    leftSpaceFac: 1,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.25,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.75,
                    topFac: 0.5,
                    leftSpaceFac: 2,
                    topSpaceFac: 1
                }
            ]
        },
        {
            key: '5-6',
            activeUrl: 'https://feed-image.baidu.com/0/pic/679435956_-1356174373_-2064476199.png',
            url: 'https://feed-image.baidu.com/0/pic/1905177273_-21900820_1841146788.png',
            itemSize: [
                {
                    widthFac: 0.5,
                    heightFac: 0.5,
                    widthSpaceFac: 1,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.5,
                    heightFac: 0.5,
                    widthSpaceFac: 1,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.5,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.5,
                    leftSpaceFac: 0,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.33333333,
                    topFac: 0.5,
                    leftSpaceFac: 1,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.66666667,
                    topFac: 0.5,
                    leftSpaceFac: 2,
                    topSpaceFac: 1
                }
            ]
        },
        {
            key: '5-7',
            activeUrl: 'https://feed-image.baidu.com/0/pic/-1902518575_-1872024539_-2140771649.png',
            url: 'https://feed-image.baidu.com/0/pic/573226295_1393583598_-842890269.png',
            itemSize: [
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 1,
                    widthSpaceFac: 2,
                    heightSpaceFac: 0,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.33333333,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.66666667,
                    topFac: 0,
                    leftSpaceFac: 2,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.5,
                    leftSpaceFac: 0,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.66666667,
                    topFac: 0.5,
                    leftSpaceFac: 2,
                    topSpaceFac: 1
                }
            ]
        },
        {
            key: '5-8',
            activeUrl: 'https://feed-image.baidu.com/0/pic/1461969157_-1682392808_1138989956.png',
            url: 'https://feed-image.baidu.com/0/pic/-1400745391_660601370_-1984936343.png',
            itemSize: [
                {
                    widthFac: 0.33333333,
                    heightFac: 1,
                    widthSpaceFac: 2,
                    heightSpaceFac: 0,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0.33333333,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.66666667,
                    topFac: 0,
                    leftSpaceFac: 2,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.33333333,
                    topFac: 0.5,
                    leftSpaceFac: 1,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.66666667,
                    topFac: 0.5,
                    leftSpaceFac: 2,
                    topSpaceFac: 1
                }
            ]
        },
        {
            key: '5-9',
            activeUrl: 'https://feed-image.baidu.com/0/pic/-1278218289_-130084141_1189820379.png',
            url: 'https://feed-image.baidu.com/0/pic/1921350329_171516691_422186242.png',
            itemSize: [
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0.33333333,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.66666667,
                    topFac: 0,
                    leftSpaceFac: 2,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.66666667,
                    heightFac: 0.5,
                    widthSpaceFac: 1,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.5,
                    leftSpaceFac: 0,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 1,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.66666667,
                    topFac: 0.5,
                    leftSpaceFac: 1,
                    topSpaceFac: 1
                }
            ]
        }
    ],
    6: [
        {
            key: '6-1',
            activeUrl: 'https://feed-image.baidu.com/0/pic/-538078419_250403104_-1931037447.png',
            url: 'https://feed-image.baidu.com/0/pic/1857204862_1631277446_-1921401076.png',
            itemSize: [
                {
                    widthFac: 0.5,
                    heightFac: 0.33,
                    widthSpaceFac: 1,
                    heightSpaceFac: 2,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.5,
                    heightFac: 0.33,
                    widthSpaceFac: 1,
                    heightSpaceFac: 2,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.5,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.5,
                    heightFac: 0.33,
                    widthSpaceFac: 1,
                    heightSpaceFac: 2,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0.33,
                    leftSpaceFac: 0,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.5,
                    heightFac: 0.33,
                    widthSpaceFac: 1,
                    heightSpaceFac: 2,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.5,
                    topFac: 0.33,
                    leftSpaceFac: 1,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.5,
                    heightFac: 0.33,
                    widthSpaceFac: 1,
                    heightSpaceFac: 2,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.66,
                    leftSpaceFac: 0,
                    topSpaceFac: 2
                },
                {
                    widthFac: 0.5,
                    heightFac: 0.33,
                    widthSpaceFac: 1,
                    heightSpaceFac: 2,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.5,
                    topFac: 0.66,
                    leftSpaceFac: 1,
                    topSpaceFac: 2
                }
            ]
        },
        {
            key: '6-2',
            activeUrl: 'https://feed-image.baidu.com/0/pic/692171908_1583155974_1608618804.png',
            url: 'https://feed-image.baidu.com/0/pic/-331190398_1804626470_745075594.png',
            itemSize: [
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0.33333333,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.66666667,
                    topFac: 0,
                    leftSpaceFac: 2,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.5,
                    leftSpaceFac: 0,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.33333333,
                    topFac: 0.5,
                    leftSpaceFac: 1,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.66666667,
                    topFac: 0.5,
                    leftSpaceFac: 2,
                    topSpaceFac: 1
                }
            ]
        },
        {
            key: '6-3',
            activeUrl: 'https://feed-image.baidu.com/0/pic/-1228090582_-273609051_1623941931.png',
            url: 'https://feed-image.baidu.com/0/pic/922376506_711622024_-421994993.png',
            itemSize: [
                {
                    widthFac: 1,
                    heightFac: 0.66,
                    widthSpaceFac: 0,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.2,
                    heightFac: 0.33,
                    widthSpaceFac: 4,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.66,
                    leftSpaceFac: 0,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.2,
                    heightFac: 0.33,
                    widthSpaceFac: 4,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.2,
                    topFac: 0.66,
                    leftSpaceFac: 1,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.2,
                    heightFac: 0.33,
                    widthSpaceFac: 4,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.4,
                    topFac: 0.66,
                    leftSpaceFac: 2,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.2,
                    heightFac: 0.33,
                    widthSpaceFac: 4,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.6,
                    topFac: 0.66,
                    leftSpaceFac: 3,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.2,
                    heightFac: 0.33,
                    widthSpaceFac: 4,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.8,
                    topFac: 0.66,
                    leftSpaceFac: 4,
                    topSpaceFac: 1
                }
            ]
        },
        {
            key: '6-4',
            activeUrl: 'https://feed-image.baidu.com/0/pic/-1723246144_-1669288857_603943745.png',
            url: 'https://feed-image.baidu.com/0/pic/-1228662278_953978021_-591644798.png',
            itemSize: [
                {
                    widthFac: 0.66666667,
                    heightFac: 1,
                    widthSpaceFac: 1,
                    heightSpaceFac: 0,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.2,
                    widthSpaceFac: 1,
                    heightSpaceFac: 4,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.66666667,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.2,
                    widthSpaceFac: 1,
                    heightSpaceFac: 4,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.66666667,
                    topFac: 0.2,
                    leftSpaceFac: 1,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.2,
                    widthSpaceFac: 1,
                    heightSpaceFac: 4,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.66666667,
                    topFac: 0.4,
                    leftSpaceFac: 1,
                    topSpaceFac: 2
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.2,
                    widthSpaceFac: 1,
                    heightSpaceFac: 4,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.66666667,
                    topFac: 0.6,
                    leftSpaceFac: 1,
                    topSpaceFac: 3
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.2,
                    widthSpaceFac: 1,
                    heightSpaceFac: 4,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.66666667,
                    topFac: 0.8,
                    leftSpaceFac: 1,
                    topSpaceFac: 4
                }
            ]
        },
        {
            key: '6-5',
            activeUrl: 'https://feed-image.baidu.com/0/pic/562395027_-483834526_-346898009.png',
            url: 'https://feed-image.baidu.com/0/pic/-850679530_106663397_-1789638865.png',
            itemSize: [
                {
                    widthFac: 0.66666667,
                    heightFac: 0.66666667,
                    widthSpaceFac: 1,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 1,
                    heightSpaceFac: 2,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.66666667,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 1,
                    heightSpaceFac: 2,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.66666667,
                    topFac: 0.33333333,
                    leftSpaceFac: 1,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.66666666,
                    leftSpaceFac: 0,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.33333333,
                    topFac: 0.66666667,
                    leftSpaceFac: 1,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 2,
                    heightSpaceFac: 2,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.66666666,
                    topFac: 0.66666666,
                    leftSpaceFac: 2,
                    topSpaceFac: 2
                }
            ]
        }
    ],
    7: [
        {
            key: '7-1',
            activeUrl: 'https://feed-image.baidu.com/0/pic/-1625179731_211401489_-754541597.png',
            url: 'https://feed-image.baidu.com/0/pic/-943820710_1908532578_767392827.png',
            itemSize: [
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 2,
                    heightSpaceFac: 2,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 2,
                    heightSpaceFac: 2,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0.33333333,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 2,
                    heightSpaceFac: 2,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.66666667,
                    topFac: 0,
                    leftSpaceFac: 2,
                    topSpaceFac: 0
                },
                {
                    widthFac: 1,
                    heightFac: 0.33333333,
                    widthSpaceFac: 0,
                    heightSpaceFac: 2,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0.33333333,
                    leftSpaceFac: 0,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 2,
                    heightSpaceFac: 2,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.66666667,
                    leftSpaceFac: 0,
                    topSpaceFac: 2
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 2,
                    heightSpaceFac: 2,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.33333333,
                    topFac: 0.66666667,
                    leftSpaceFac: 1,
                    topSpaceFac: 2
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 2,
                    heightSpaceFac: 2,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.66666667,
                    topFac: 0.66666667,
                    leftSpaceFac: 2,
                    topSpaceFac: 2
                }
            ]
        },
        {
            key: '7-2',
            activeUrl: 'https://feed-image.baidu.com/0/pic/1378617968_-230114427_1734101776.png',
            url: 'https://feed-image.baidu.com/0/pic/-853526923_1805799529_755294752.png',
            itemSize: [
                {
                    widthFac: 0.25,
                    heightFac: 0.5,
                    widthSpaceFac: 3,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.25,
                    heightFac: 0.5,
                    widthSpaceFac: 3,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0.25,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.25,
                    heightFac: 0.5,
                    widthSpaceFac: 3,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0.5,
                    topFac: 0,
                    leftSpaceFac: 2,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.25,
                    heightFac: 0.5,
                    widthSpaceFac: 3,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.75,
                    topFac: 0,
                    leftSpaceFac: 3,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.5,
                    leftSpaceFac: 0,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.33333333,
                    topFac: 0.5,
                    leftSpaceFac: 1,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.5,
                    widthSpaceFac: 2,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.66666667,
                    topFac: 0.5,
                    leftSpaceFac: 2,
                    topSpaceFac: 1
                }
            ]
        },
        {
            key: '7-3',
            activeUrl: 'https://feed-image.baidu.com/0/pic/1606324929_-434902085_-293644823.png',
            url: 'https://feed-image.baidu.com/0/pic/-546869019_1075413599_-919203329.png',
            itemSize: [
                {
                    widthFac: 0.5,
                    heightFac: 0.33333333,
                    widthSpaceFac: 1,
                    heightSpaceFac: 2,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.5,
                    heightFac: 0.33333333,
                    widthSpaceFac: 1,
                    heightSpaceFac: 2,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.5,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 2,
                    heightSpaceFac: 2,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0.33,
                    leftSpaceFac: 0,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 2,
                    heightSpaceFac: 2,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0.33333333,
                    topFac: 0.33333333,
                    leftSpaceFac: 1,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 2,
                    heightSpaceFac: 2,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.66666667,
                    topFac: 0.33333333,
                    leftSpaceFac: 2,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.5,
                    heightFac: 0.33333333,
                    widthSpaceFac: 1,
                    heightSpaceFac: 2,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.66666667,
                    leftSpaceFac: 0,
                    topSpaceFac: 2
                },
                {
                    widthFac: 0.5,
                    heightFac: 0.33333333,
                    widthSpaceFac: 1,
                    heightSpaceFac: 2,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.5,
                    topFac: 0.66666667,
                    leftSpaceFac: 1,
                    topSpaceFac: 2
                }
            ]
        }
    ],
    8: [
        {
            key: '8-1',
            activeUrl: 'https://feed-image.baidu.com/0/pic/-1079720688_949682004_-1785863182.png',
            url: 'https://feed-image.baidu.com/0/pic/854990564_545562545_156117136.png',
            itemSize: [
                {
                    widthFac: 0.5,
                    heightFac: 0.25,
                    widthSpaceFac: 1,
                    heightSpaceFac: 3,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.5,
                    heightFac: 0.25,
                    widthSpaceFac: 1,
                    heightSpaceFac: 3,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.5,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.5,
                    heightFac: 0.25,
                    widthSpaceFac: 1,
                    heightSpaceFac: 3,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0.25,
                    leftSpaceFac: 0,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.5,
                    heightFac: 0.25,
                    widthSpaceFac: 1,
                    heightSpaceFac: 3,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.5,
                    topFac: 0.25,
                    leftSpaceFac: 1,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.5,
                    heightFac: 0.25,
                    widthSpaceFac: 1,
                    heightSpaceFac: 3,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0.5,
                    leftSpaceFac: 0,
                    topSpaceFac: 2
                },
                {
                    widthFac: 0.5,
                    heightFac: 0.25,
                    widthSpaceFac: 1,
                    heightSpaceFac: 3,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.5,
                    topFac: 0.5,
                    leftSpaceFac: 1,
                    topSpaceFac: 2
                },
                {
                    widthFac: 0.5,
                    heightFac: 0.25,
                    widthSpaceFac: 1,
                    heightSpaceFac: 3,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.75,
                    leftSpaceFac: 0,
                    topSpaceFac: 3
                },
                {
                    widthFac: 0.5,
                    heightFac: 0.25,
                    widthSpaceFac: 1,
                    heightSpaceFac: 3,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.5,
                    topFac: 0.75,
                    leftSpaceFac: 1,
                    topSpaceFac: 3
                }
            ]
        },
        {
            key: '8-2',
            activeUrl: 'https://feed-image.baidu.com/0/pic/424668432_-1499509848_-1556469237.png',
            url: 'https://feed-image.baidu.com/0/pic/1579339749_481846349_-790796062.png',
            itemSize: [
                {
                    widthFac: 0.25,
                    heightFac: 0.5,
                    widthSpaceFac: 3,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.25,
                    heightFac: 0.5,
                    widthSpaceFac: 3,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0.25,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.25,
                    heightFac: 0.5,
                    widthSpaceFac: 3,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0.5,
                    topFac: 0,
                    leftSpaceFac: 2,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.25,
                    heightFac: 0.5,
                    widthSpaceFac: 3,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.75,
                    topFac: 0,
                    leftSpaceFac: 3,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.25,
                    heightFac: 0.5,
                    widthSpaceFac: 3,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.5,
                    leftSpaceFac: 0,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.25,
                    heightFac: 0.5,
                    widthSpaceFac: 3,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.25,
                    topFac: 0.5,
                    leftSpaceFac: 1,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.25,
                    heightFac: 0.5,
                    widthSpaceFac: 3,
                    heightSpaceFac: 1,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.5,
                    topFac: 0.5,
                    leftSpaceFac: 2,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.25,
                    heightFac: 0.5,
                    widthSpaceFac: 3,
                    heightSpaceFac: 1,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.75,
                    topFac: 0.5,
                    leftSpaceFac: 3,
                    topSpaceFac: 1
                }
            ]
        }
    ],
    9: [
        {
            key: '9-1',
            activeUrl: 'https://feed-image.baidu.com/0/pic/1451157561_-1474816676_1411406775.png',
            url: 'https://feed-image.baidu.com/0/pic/1451157561_-1474816676_1411406775.png',
            itemSize: [
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 2,
                    heightSpaceFac: 2,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0,
                    leftSpaceFac: 0,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 2,
                    heightSpaceFac: 2,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0.33333333,
                    topFac: 0,
                    leftSpaceFac: 1,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 2,
                    heightSpaceFac: 2,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.66666666,
                    topFac: 0,
                    leftSpaceFac: 2,
                    topSpaceFac: 0
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 2,
                    heightSpaceFac: 2,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0,
                    topFac: 0.33333333,
                    leftSpaceFac: 0,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 2,
                    heightSpaceFac: 2,
                    marginRightFac: 1,
                    marginBottomFac: 1,
                    leftFac: 0.33333333,
                    topFac: 0.33333333,
                    leftSpaceFac: 1,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 2,
                    heightSpaceFac: 2,
                    marginRightFac: 0,
                    marginBottomFac: 1,
                    leftFac: 0.66666666,
                    topFac: 0.33333333,
                    leftSpaceFac: 2,
                    topSpaceFac: 1
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 2,
                    heightSpaceFac: 2,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0,
                    topFac: 0.66666666,
                    leftSpaceFac: 0,
                    topSpaceFac: 2
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 2,
                    heightSpaceFac: 2,
                    marginRightFac: 1,
                    marginBottomFac: 0,
                    leftFac: 0.33333333,
                    topFac: 0.66666666,
                    leftSpaceFac: 1,
                    topSpaceFac: 2
                },
                {
                    widthFac: 0.33333333,
                    heightFac: 0.33333333,
                    widthSpaceFac: 2,
                    heightSpaceFac: 2,
                    marginRightFac: 0,
                    marginBottomFac: 0,
                    leftFac: 0.66666666,
                    topFac: 0.66666666,
                    leftSpaceFac: 2,
                    topSpaceFac: 2
                }
            ]
        }
    ]
};
